<template>

	<div class="container my-4" v-if="$route.name !== 'home' && page.permalink !== 'home'">
		<breadcrumb :items="breadcrumb"/>
	</div>

	<div v-if="page?.children?.length > 0" class="container">
		<div class="row">
			<div class="col-12 col-lg-3 page-view-sidebar">
				<v-card :header="page.parent.title ?? page.title">
					<div class="d-flex flex-column mt-3">
						<router-link
								v-for="child in page.children"
								:to="{path: child.permalink}"
								class="page-view-sidebar__item py-2 d-block"
						>
							{{ child.title }}
						</router-link>
					</div>
				</v-card>
			</div>
			<div class="col-12 col-lg-9">
				<page-builder :components-data="page.components"/>
			</div>
		</div>
	</div>
	<page-builder v-else :components-data="page.components"/>
	<v-loader v-if="loader"/>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import axios from "axios";
import {PageDataClass} from "./Interfaces/PageDataInterface";
import PageBuilder from "./PageBuilder.vue";
import Sweetalert2 from "sweetalert2";
import VCard from "../../Components/VCard.vue";
import Breadcrumb from "./Components/Breadcrumb.vue";
import {BreadcrumbInterface} from "./Interfaces/BreadcrumbInterface";
import VLoader from "../../Components/VLoader.vue";

export default defineComponent({
	name: "Home",
	components: {
		VCard,
		PageBuilder,
		Breadcrumb,
		VLoader
	},
	data() {
		return {
			page: new PageDataClass(),
			breadcrumb: [] as BreadcrumbInterface[],
			loader: false,
		}
	},
	mounted() {
		this.getPage();
	},
	watch: {
		permalink() {
			this.getPage();
		},
	},
	computed: {
		permalink(): any {
			return (this.$route?.hasOwnProperty('params') && this.$route.params?.hasOwnProperty('permalink') ? this.$route.params.permalink : 'home');
		}
	},
	methods: {
		getPage(): void {
			this.loader = true;
			axios.get(`/api/pages/${this.permalink}`).then((response: any) => {
				if (response.status === 200 && response.data.success === true) {
					this.page = response.data.item;
					let isLanding = (location.href).search('landing');
					if (isLanding > -1 && this.page.type === 'simple') {
						Sweetalert2.fire(this.translate('ops-error-title'), this.translate('not-found-page'), 'error');
						this.$router.push({name: 'home'});
					}

					// Breadcrumb
					this.breadcrumb = [];
					if (Object.keys(this.page.parent).length > 0) {
						this.breadcrumb.push({title: this.page.parent.title, route: this.page.parent.permalink});
					}
					this.breadcrumb.push({title: this.page.title, route: this.page.permalink});
				}
			}).catch((error: any) => {
				if (error.response.status === 404) {
					Sweetalert2.fire(this.translate('ops-error-title'), this.translate('not-found-page'), 'error');
					this.$router.push({name: 'home'});
				} else {
					Sweetalert2.fire(this.translate('ops-error-title'), this.translate('ops-error-text'), 'error');
				}
			}).finally(() => {
				this.loader = false;
			});
		}
	}
});
</script>

<style scoped>

</style>
